// Exports
export default {
	"root": "root_YEAmx",
	"withGlobalBar": "withGlobalBar_CjERs",
	"withPremiumButton": "withPremiumButton_cGsWv",
	"buffer": "buffer_EGa+V",
	"unresizable": "unresizable_o+XLD",
	"resizable": "resizable_YQzR9",
	"spacer": "spacer_aLyJt"
};
